import { TYPES } from "./types";
import { tkt1FileUploadManagementService } from "../services"; 

export const getTKT1FileUploads = (query, currentUrl) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.getFileUploads(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOADS_SUCCESS,
        payload: {data, currentUrl},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOADS_FAIL,
        payload: {currentUrl},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
        currentUrl,
      },
    });
  }
};

export const getTKT1FileUploadStats = () => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.getFileUploadStats();
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOAD_STATS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOAD_STATS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1FileUploads = (query) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.searchFileUploads(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_FILE_UPLOADS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_FILE_UPLOADS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1FileUploadByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.getFileUploadByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1FileUpload = (id, fileData) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.updateFileUpload(id, fileData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_FILE_UPLOAD_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_FILE_UPLOAD_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1FileUpload = (fileData) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.createFileUpload(fileData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_FILE_UPLOAD_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_FILE_UPLOAD_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1FileUpload = (id) => async (dispatch) => {
  try {
    const result = await tkt1FileUploadManagementService.deleteFileUpload(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_FILE_UPLOAD_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_FILE_UPLOAD_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1FileUploadManagementAction = {
  getTKT1FileUploads,
  getTKT1FileUploadStats,
  searchTKT1FileUploads,
  getTKT1FileUploadByID,
  createTKT1FileUpload,
  updateTKT1FileUpload,
  deleteTKT1FileUpload
};
